var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 -3 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2469_2661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.91 7.49C16.2524 7.49 16.53 7.21242 16.53 6.87C16.53 6.52758 16.2524 6.25 15.91 6.25C15.5676 6.25 15.29 6.52758 15.29 6.87C15.29 7.21242 15.5676 7.49 15.91 7.49Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.04 6.23999H0.809998V7.48999H14.04V6.23999Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34999 13.74L0.349993 7.73997C0.233585 7.62386 0.141227 7.48592 0.0782108 7.33405C0.0151947 7.18219 -0.0172424 7.01939 -0.0172424 6.85497C-0.0172424 6.69055 0.0151947 6.52775 0.0782108 6.37589C0.141227 6.22402 0.233585 6.08608 0.349993 5.96997L6.34999 -0.0300293L7.23999 0.849971L1.23999 6.84997L7.23999 12.85L6.34999 13.74Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2469_2661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.54,
    height: 13.74,
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.419eaa9f.svg";
export { ForwardRef as ReactComponent };